import { render, staticRenderFns } from "./CourseFree.vue?vue&type=template&id=23e452d4&"
import script from "./CourseFree.vue?vue&type=script&lang=js&"
export * from "./CourseFree.vue?vue&type=script&lang=js&"
import style0 from "./CourseFree.vue?vue&type=style&index=0&id=23e452d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports